import React from "react";
import FounderSection from "./FounderSection";
import About from "./About";
import Tutor from "./Tutor";
import Banner from "../Common/Banner";
import JourneyCarousel from "./JourneyCarousel";

export default function AboutPage() {
  return (
    <div>
    <Banner title="About Us" currentpage="About"/>
      <About show={false} />
      <FounderSection/>
      <Tutor/>
      <JourneyCarousel/>
    </div>
  );
}
